module.exports = __webpack_public_path__ + "static/img/banner-1.a60720c2.jpg";